<template>
  <div class="modal animated is-active">
    <div class="modal-background"></div>
    <div class="modal-card is-large">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
      </header>
      <section class="modal-card-body">
        <div class="notification is-danger" v-if="error !== ''">{{ error }}</div>
        <p class="control">
          <label class="label">Status</label>
          <select class="select is-fullwidth" v-model="provider.status" name="status" id="status">
            <option value="2">Prospection</option>
            <option value="3">Negotiation</option>
            <option value="1">Active</option>
            <option value="0">Inactive</option>
          </select>
        </p>
        <p class="control">
          <label class="label">Commecial Representative</label>
          <input class="input" type="text" name="commecial_representative" id="commecial_representative" v-model="provider.commecial_representative">
        </p>
        <p class="control">
          <label class="label">Account Executive</label>
          <input class="input" type="text" name="account_executive" id="account_executive" v-model="provider.account_executive">
        </p>
        <p class="control">
          <label class="label">Observation</label>
          <input class="input" type="text" name="relationship_obs" id="relationship_obs" v-model="provider.relationship_obs">
        </p>
        <p class="control">
          <label class="checkbox">
            <input type="checkbox" v-model="provider.contract_arrived">
            Contract arrived at the company
          </label>
        </p>
        <p class="control">
          <label class="checkbox">
            <input type="checkbox" v-model="provider.firm_recognized">
            Firm recognized
          </label>
        </p>
        <p class="control">
          <label class="checkbox">
            <input type="checkbox" v-model="provider.forwarded_supplier">
            Forwarded to the supplier
          </label>
        </p>
        <p class="control">
          <label class="checkbox">
            <input type="checkbox" v-model="provider.archived">
            Archived
          </label>
        </p>
        <p class="control is-expanded" >
          <label class="label">Contract</label>
          <input type="file" id="contract" ref="contract" v-on:change="handleFileUploadContract()"/>
        </p>
        <template v-for="(contract, index) in contracts">
          <p class="control is-expanded">
            <span><a :href="contract.url" target="_blank">{{ contract.file }}</a> <a class="button is-small " @click="removeContract(index)"><i class="fa fa-trash"></i></a></span>
          </p>
        </template>
        <p class="control">
          <label class="label">Contract Data</label>
          <input class="input" type="text" name="contract_data" id="contract_data" v-model="provider.contract_data">
        </p>
        <template v-if="provider.new_provider_file === '' || provider.new_provider_file === null">
          <p class="control is-expanded" >
            <label class="label">New Provider</label>
            <input type="file" id="new_provider" ref="new_provider" v-on:change="handleFileUploadNewProvider()"/>
          </p>
        </template>
        <template v-else>
          <p class="control is-expanded" >
            <label class="label">New Provider</label>
            <span><a @click="new_provider()">{{ provider.contract_file }}</a> <a class="button is-small " @click="changeContract"><i class="fa fa-refresh"></i></a></span>
          </p>
        </template>
        <p class="control">
          <label class="label">EZ Company</label>
          <select class="select is-fullwidth" v-model="provider.ez_company" name="ez_company" id="ez_company">
            <option value="1">Ezlink - LDS Operadora</option>
            <option value="2">Ezhotels</option>
            <option value="3">Dehe Group</option>
            <option value="4">PMC</option>
          </select>
        </p>
        <p class="control">
          <label class="label">Integration</label>
          <select class="select is-fullwidth" v-model="provider.integration" name="integration" id="integration">
            <option value="1">Web</option>
            <option value="2">XML</option>
            <option value="3">API</option>
          </select>
        </p>
        <p class="control">
          <label class="label">Integrated system</label>
          <select class="select is-fullwidth" v-model="provider.integrated_system" name="integrated_system" id="integrated_system">
            <option value="1">Wooba</option>
            <option value="2">Cangooroo</option>
            <option value="3">Juniper</option>
            <option value="4">Booking Motor</option>
            <option value="5">TravelGate</option>
            <option value="6">Infotera</option>
            <option value="7">Itravel</option>
            <option value="8">TravelTech</option>
            <option value="9">Nemo</option>
            <option value="0">Other</option>
          </select>
        </p>
        <p class="control" v-if="parseInt(provider.integrated_system) === 0">
          <label class="label">Other Integrated System</label>
          <input class="input" type="text" name="integrated_system_other" id="integrated_system_other" v-model="provider.integrated_system_other">
        </p>
        <p class="control">
          <label class="checkbox">
            <input type="checkbox" v-model="provider.cross_selling">
            Cross-Selling
          </label>
        </p>
        <p class="control">
          <label class="label">Training date</label>
          <input class="input" type="text" name="training_date" id="training_date" v-model="provider.training_date">
        </p>
        <p class="control">
          <label class="label">Training participants</label>
          <input class="input" type="text" name="training_participants" id="training_participants" v-model="provider.training_participants">
        </p>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a :class="{'button': true, 'is-primary': true, 'is-disabled': inProgress}" @click="close(true)">Close</a>
          </p>
          <p class="control">
            <a :class="{'button': true, 'is-success': true, 'is-loading': inProgress}" @click="save">Save</a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  import babelPolyfill from 'babel-polyfill'
  export default {
    props: {
      context: {
        type: Object
      },
      callback: {
        type: String
      },
      title: {
        type: String
      },
      provider_id: {
        type: Number
      }
    },
    data () {
      return {
        provider: {
          payment_type: 1,
          limit: 0,
          rule_id: 1
        },
        contracts: '',
        file: null,
        file2: null,
        inProgress: false,
        error: '',
        rules: [],
        bank_data: []
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.loadData()
        this.loadContracts()
      })
    },
    methods: {
      removeContract (index) {
        this.context.$http.post(this.context.$store.state.config.apiURL + '/providers/files/contract/delete/' + this.provider_id, { file: this.contracts[index].file }).then((response) => {
          this.inProgress = false
          this.loadContracts()
        }, (response) => {
          this.inProgress = false
          this.error = response.body
        })
      },
      handleFileUploadContract () {
        this.file = this.$refs.contract.files[0]
        this.error = ''
      },
      changeContract () {
        this.file2 = null
        this.provider.new_provider_file = null
      },
      async submitFileContract () {
        if (this.file !== null) {
          let data = new window.FormData()
          data.append('file', this.file)
          data.append('provider_id', this.provider_id)
          this.context.$http.post(this.context.$store.state.config.apiURL + '/providers/files/contract', data, {headers: {'Content-Type': 'multipart/form-data'}}).then((response) => {
            return true
          }, (response) => {
            return true
          })
        } else {
          return true
        }
      },
      handleFileUploadNewProvider () {
        this.file2 = this.$refs.new_provider.files[0]
        this.error = ''
      },
      async submitFileNewProvider () {
        if (this.file2 !== null) {
          let data = new window.FormData()
          data.append('file', this.file2)
          data.append('provider_id', this.provider_id)
          this.context.$http.post(this.context.$store.state.config.apiURL + '/providers/files/new_provider', data, {headers: {'Content-Type': 'multipart/form-data'}}).then((response) => {
            return true
          }, (response) => {
            return true
          })
        } else {
          return true
        }
      },
      close (closeOnly, result) {
        if (!closeOnly) {
          this.context[this.callback](result)
        }
        this.$el.remove()
      },
      newProvider (id) {
        window.location.href = this.context.$store.state.config.apiURL + '/providers/files/new_provider/' + this.provider_id
      },
      async save () {
        this.$validator.validateAll()
        await this.submitFileContract()
        await this.submitFileNewProvider()
        // if (this.$validator.errorBag.errors.length === 0) {
        this.inProgress = true
        this.error = ''
        this.context.$http.post(this.context.$store.state.config.apiURL + '/providers/relationship/' + this.provider_id, this.provider).then((response) => {
          this.inProgress = false
          this.close(false, {ok: true, message: 'The Provider Relationship ' + response.body.name + ' was successfully save'})
        }, (response) => {
          this.inProgress = false
          this.error = response.body
        })
        // }
      },
      loadData () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/providers/' + this.provider_id).then((response) => {
          this.provider = response.body
          document.body.appendChild(this.$el)
        }, (response) => {
        })
      },
      loadContracts () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/providers/files/contract/' + this.provider_id).then((response) => {
          this.contracts = response.body
          document.body.appendChild(this.$el)
        }, (response) => {
        })
      }
    },
    components: {
      babelPolyfill
    },
    computed: {
      enterClass () {
        return `${this.transition}In`
      },
      leaveClass () {
        return `${this.transition}Out`
      }
    }
  }
</script>
<style lang="scss" scoped>
  .is-title {
    text-transform: capitalize;
  }

  .panel {
    background-color: white;
    box-shadow: 0px 2px 3px rgb(167, 28, 32), 0px 0px 0px 1px rgb(167, 28, 32);
    color: #4a4a4a;
    max-width: 100%;
    position: relative;
    border: 0px;
    border-radius: 0px;
  }

  .panel-heading {
    color: #FFFFFF;
    font-weight: bold;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: flex;
    min-height: 40px;
    box-shadow: 0px 1px 0px rgb(167, 28, 32), 0px 0px 0px 0px rgb(167, 28, 32);
    background-color: rgb(167, 28, 32);
    border-bottom: 0px;
    border-radius: 0px;
    font-size: 1rem;
  }
</style>



// WEBPACK FOOTER //
// ProviderRelationship.vue?13b8685d